import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Ward } from './ward.model';

export const WardActions = createActionGroup({
  source: 'Ward/API',
  events: {
    'Load Wards': props<{ wards: Ward[] }>(),
    'Add Ward': props<{ ward: Ward }>(),
    'Upsert Ward': props<{ ward: Ward }>(),
    'Add Wards': props<{ wards: Ward[] }>(),
    'Upsert Wards': props<{ wards: Ward[] }>(),
    'Update Ward': props<{ ward: Update<Ward> }>(),
    'Update Wards': props<{ wards: Update<Ward>[] }>(),
    'Delete Ward': props<{ id: string }>(),
    'Delete Wards': props<{ ids: string[] }>(),
    'Clear Wards': emptyProps(),

    // Effect actions
    'Get All Wards By District':props<{ districtUniqueId: string }>(),
    'Wards Loading State': props<{ loading: boolean }>(),
  }
});
